import { MWList, MWListBE, MWListForCreate, SharedList, SharedListBE } from '@/types/message-whale/mwList';

export const mapMWListBEsToDTO = (listBE: MWListBE): MWList => {
  return {
    id: listBE.id.toString(),
    name: listBE.name,
    created: listBE.created_at,
    updated: listBE.updated_at,
    subscribersCount: listBE.subscribers_count,
    customFields: listBE.custom_fields,
    isShared: listBE.is_shared,
  };
};

export const mapMWListsBEsToDTO = (
  listBEArray: MWListBE[]
): MWList[] => {
  return listBEArray.map((listBE) => {
    return mapMWListBEsToDTO(listBE);
  });
};

export const mapMWListDTOToBEForCreate = (
  list: Partial<MWListForCreate>
): Partial<MWListBE> & { syncIntegration?: boolean } => {
  return {
    name: list.name,
    custom_fields: null,
    syncIntegration: list.syncIntegrationSubscribers,
  };
};

export const mapMWListDTOToBEForUpdate = (
  list: Partial<MWList>
): Partial<MWListBE> => {
  return {
    name: list.name,
    custom_fields: list.customFields,
  };
};

export const mapSharedListBEsToDTO = (
  listBE: SharedListBE
): SharedList => {
  return {
    id: listBE.id.toString(),
    name: listBE.name,
    organizationId: listBE.organization_id,
    listId: listBE.list_id,
    sharedBy: listBE.shared_by,
    enabled: listBE.enabled,
    created: listBE.created_at,
    updated: listBE.updated_at,
  };
};

export const mapSharedListsBEsToDTO = (
  listBEArray: SharedListBE[]
): SharedList[] => {
  return listBEArray.map((listBE) => {
    return mapSharedListBEsToDTO(listBE);
  });
};

export const mapSharedListDTOToBE = (
  list: Partial<SharedList>
): Partial<SharedListBE> => {
  return {
    organization_id: list.organizationId,
    list_id: list.listId,
    shared_by: list.sharedBy,
    enabled: list.enabled,
  };
};

export const mapSharedListDTOToBEForCreate = (
  list: Partial<SharedList>
): Partial<SharedListBE> => {
  return {
    organization_id: list.organizationId,
    list_id: list.listId,
    shared_by: list.sharedBy,
    enabled: list.enabled,
  };
};

export const mapSharedListDTOToBEForUpdate = (
  list: Partial<SharedList>
): Partial<SharedListBE> => {
  return {
    organization_id: list.organizationId,
    list_id: list.listId,
    shared_by: list.sharedBy,
    enabled: list.enabled,
  };
};
